import { render, staticRenderFns } from "./SvgGridOverlay.vue?vue&type=template&id=37af3352&scoped=true"
import script from "./SvgGridOverlay.vue?vue&type=script&lang=js"
export * from "./SvgGridOverlay.vue?vue&type=script&lang=js"
import style0 from "./SvgGridOverlay.vue?vue&type=style&index=0&id=37af3352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37af3352",
  null
  
)

export default component.exports